import Base from './base'
import {
  EmailReplies as EmailRepliesList,
  ReceivedSentiment,
  UpdatedEmailReply,
} from '../types/emailReplies'

export default class EmailReplies extends Base {
  async get(id: string): Promise<EmailRepliesList> {
    return this.api.get(`/email_replies/?message_id=${encodeURIComponent(id)}`)
  }

  async put(params: ReceivedSentiment): Promise<UpdatedEmailReply> {
    return this.api.put(`/email_replies/${params.id}`, {
      sentiment: params.sentiment,
    })
  }
}
